import { render, staticRenderFns } from "./openclass-detail.vue?vue&type=template&id=42aa5456"
import script from "./openclass-detail.vue?vue&type=script&lang=js"
export * from "./openclass-detail.vue?vue&type=script&lang=js"
import style0 from "./openclass-detail.vue?vue&type=style&index=0&id=42aa5456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports